import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { LoanData, ProductCode } from '../../loan/domain/models/loan.model';
import { LoanDataOptionItem } from './loans-select-dialog.model';
import { BaseDialogActionData, ButtonColor, CommonActionKey, CustomerLoanStatus, NeedsAttentionHelper, NeedsAttentionModel } from 'common';

@Component({
    selector: 'ifp-loans-select-dialog',
    templateUrl: './loans-select-dialog.component.html',
    styleUrls: ['./loans-select-dialog.component.scss'],
    standalone: false
})
export class LoansSelectDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'OK', buttonColor: ButtonColor.Primary },
  ];

  selected: LoanDataOptionItem;
  loanOptions: LoanDataOptionItem[];

  form: UntypedFormGroup;

  constructor(
    private readonly dialogRef: MatDialogRef<LoansSelectDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.form = this.formBuilder.group({ loanNumber: '' });
    this.loanOptions = this.getLoanOptions(this.data?.loans);
  }

  shouldShowTooltip(label: any): boolean {
    return !(label?.offsetWidth > label?.offsetParent?.offsetWidth);
  }

  static show(dialog: MatDialog, title: string, loans: LoanData[], needsAttentionModel?: NeedsAttentionModel): Observable<any> {
    return dialog.open(LoansSelectDialogComponent, {
      width: '510px',
      data: {
        title: title,
        loans: loans,
        needsAttentionModel: needsAttentionModel
      },
      closeOnNavigation: true
    }).afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Ok) {
      this.dialogRef.close(this.selected.value);
      return;
    }
    this.dialogRef.close();
  }

  private getLoanOptions(loans: LoanData[]): LoanDataOptionItem[] {
    if (!loans) {
      return [];
    }

    return loans.map(loan => {
      let result = {
        label: this.getLoanLabel(loan),
        value: loan,
        tooltip: this.getLoanLabel(loan),
      } as LoanDataOptionItem;

      if (loan.customerFacingStatus === CustomerLoanStatus.NeedsAttention) {
        result = {
          ...result,
          iconName: 'warning',
          iconClass: 'mat-orange',
          iconTooltip: NeedsAttentionHelper.getNeedsAttentionMessageWithProductCode(this.data.needsAttentionModel.messageInput, loan.productCode)
        };
      }

      return result;
    });
  }

  private getLoanLabel(loan: LoanData): string {
    return loan?.productCode !== ProductCode.Law ? loan?.loanNumber : loan?.description;
  }
}
